import PhfExposure from '@utils/phf/PhfExposure';
import { PushCode } from '@services/messageHub/instance';

export const PhfMessageCustomMetris = {
    PHF_RECEIVE_PUSH_MESSAGE: 'PHF_RECEIVE_PUSH_MESSAGE',
    PHF_AUTO_ACCEPT_SUCCESS: 'PHF_AUTO_ACCEPT_SUCCESS',
};

export const reportPhfPushMessageReceive = (
    pushCode: PushCode,
    params: {
        tags?: { [key: string]: any };
        message?: { [key: string]: any };
    },
) => {
    try {
        const Exposure = PhfExposure.getInstance();
        const { message = {}, tags = {} } = params;
        const orderViewId = message.wmOrderViewId || '';
        Exposure.reportPhfCardCustomMetrics(PhfMessageCustomMetris.PHF_RECEIVE_PUSH_MESSAGE, 1, {
            orderViewId,
            pushCode,
            from: 'push', //消息来源：push|poller
            ...tags,
        });
    } catch (e) {
        // console.log(e)
    }
};
